export type CostBuilderDemoMediaType = 'video' | 'image';

export interface CostBuilderDemoMedia {
  type: CostBuilderDemoMediaType;
  source: string;
  poster?: string;
  caption?: string;
}

export interface CostBuilderDemoStep {
  id: string;
  title: string;
  description: string;
  media: CostBuilderDemoMedia;
}

export interface CostBuilderDemoConfig {
  steps: CostBuilderDemoStep[];
}

export const COST_BUILDER_DEMO_STEPS: CostBuilderDemoStep[] = [
  {
    id: 'build-unit-cost',
    title: 'Building Your Unit Cost',
    description:
      'Learn how to break down raw materials, labor, and other inputs so the unit cost reflects your true production expense.',
    media: {
      type: 'video',
      source: '1-building-your-unit-cost.mov'
    }
  },
  {
    id: 'per-unit-vs-fixed',
    title: 'Per Unit vs. Fixed Costs',
    description:
      'Understand when to assign costs per unit or as a fixed amount to capture setup, tooling, and recurring charges accurately.',
    media: {
      type: 'video',
      source: '2-per-unit-vs-fixed-costs.mov'
    }
  },
  {
    id: 'markup-unit-costs',
    title: 'Markup Unit Costs',
    description:
      'See how markup applies to your calculated costs so you can protect margins and deliver competitive pricing.',
    media: {
      type: 'video',
      source: '3-markup-unit-costs.mov'
    }
  },
  {
    id: 'quote-quickly',
    title: 'Need to Quote Quickly?',
    description:
      'Discover shortcuts for reusing prior work and saving time while keeping each quote accurate and complete.',
    media: {
      type: 'video',
      source: '4-need-to-quote-quickly.mov'
    }
  },
  {
    id: 'buyer-view',
    title: 'What Buyers See',
    description:
      'Preview the buyer-facing summary so you know exactly how your cost builder inputs appear when you submit the quote.',
    media: {
      type: 'image',
      source: '5-what-buyers-see.png'
    }
  }
];

export const COST_BUILDER_TOTAL_STEPS = COST_BUILDER_DEMO_STEPS.length;

